<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <h2 class="text-center p-3">รายการรับอื่นๆ</h2>
            <!---header--->
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">
                            วันที่จ่ายเงิน
                        </label>
                        <div class="col-sm-8">
                            <date-picker
                                v-model="form.date"
                                class="w-100"
                                :format="changeFormat"
                                :lang="lang"
                                :disabled="disable_date"
                                placeholder="วันที่จ่ายเงิน">
                            </date-picker>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">
                            ลูกหนี้
                        </label>
                        <div class="col-sm-8">
                            <multiselect
                                v-model="form.customer"
                                :options="optionCustomer"
                                label="store_name"
                                :show-labels="false"
                                placeholder="กรุณาเลือกลูกค้า"
                                track-by="id">
                            </multiselect>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">
                            ยอดจ่าย
                        </label>
                        <div class="col-sm-8">
                            <input type="number" v-model="calculateTotal" class="form-control" disabled/>
                        </div>
                    </div>
                    <div class="form-group row" v-if="form.transactions.length > 0">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">ประเภทการชำระเงิน</label>
                        <div class="col-sm-6">
                            <template v-for="transaction in form.transactions">
                                <input type="checkbox" v-model="transaction.transaction_type_id"
                                       checked disabled/>
                                <span v-if="transaction.transaction_type">
                                    {{ transaction.transaction_type.name }} : {{ transaction.amount | currency }} บาท
                                    (วันที่ {{ transaction.date ? transaction.date : form.date | moment("DD/MM/YYYY") }})
                                </span>
                                <br>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <!---content--->
            <div class="table-responsive" style="min-height: 300px">
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th scope="col">ลำดับ</th>
                        <th scope="col" width="350px">รหัสบัญชี</th>
                        <th scope="col">รายการ</th>
                        <th scope="col" width="150px">ช่องรับ</th>
                        <th scope="col">เพิ่ม / ลบ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(detail,index) in details">
                        <td>{{ ++index }}</td>
                        <td>
                            <multiselect
                                v-model="detail.account"
                                :options="optionPayoffAccount"
                                :custom-label="accountLabel"
                                :show-labels="false"
                                placeholder="กรุณาเลือกบัญชี"
                                track-by="id">
                            </multiselect>
                            <div style="display: none">
                                {{ detail.account ? detail.account_other_id = detail.account.id : "" }}
                            </div>
                        </td>
                        <td>
                            <template v-if="detail.account">
                                {{ detail.account.name }}
                            </template>
                        </td>
                        <td>
                            <input class="form-control" type="number"
                                   :disabled="!detail.account"
                                   v-model="detail.amount"/>
                        </td>
                        <td>
                            <button type="button" class="btn btn-primary"
                                    @click="addOtherDetails"
                                    v-if="details.length == index">
                                <icon name="plus"></icon>
                            </button>
                            <button type="button" class="btn btn-danger"
                                    @click="removeOtherDetails(index)"
                                    v-if="index < details.length">
                                <icon name="trash"></icon>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <br/>
            <div class="col text-center" style="margin-left: 30px" v-if="form.payoff_status_id==0">
                <button type="button" class="btn btn-success" @click="goToTransaction">
                    <icon name="save"></icon>
                    บันทึก
                </button>
                &nbsp;&nbsp;
                <button type="button" class="btn btn-outline-secondary" @click="goToInvoiceOtherList">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>
            <br/>
        </div>
        <!--modal transaction-->
        <b-modal size="lg" hide-footer hide-header ref="transaction">
            <div>
                <invoice-payoff-transaction-modal @submit="saveInvoicePayoffOther">
                </invoice-payoff-transaction-modal>
            </div>
        </b-modal>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import {mapState} from "vuex"
import Multiselect from "vue-multiselect";
import InvoicePayoffTransactionModal from "./InvoicePayoffTransactionModal";
import moment from "moment";

export default {
    name: "invoice-payoff-other-form",
    props: {
        id: {default: null},
        payoff_status_id: {default: null},
    },
    data() {
        return {
            disable_date: false,
            optionCustomer: [],
            invoice_payoff: "",
            items: [
                {
                    text: "รายการตัดชำระอื่นๆ",
                    to: {name: "invoice-payoff-other"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    components: {
        InvoicePayoffTransactionModal,
        DatePicker,
        Multiselect
    },
    created() {
        if (this.form.id) {
            this.disable_date = true;
        }
        if (this.id) {
            this.disable_date = true;
        }
        this.getCustomerAll();
        this.$store.dispatch("Account/getAllInvoicePayoffAccount");
    },
    computed: {
        ...mapState({
            optionPayoffAccount: state => {
                return state.Account.payoffAccountAll;
            },
            details: state => {
                return state.InvoicePayoff.form.other_details
            },
            form: state => {
                return state.InvoicePayoff.form
            },
            user: state => {
                return state.Auth.user;
            }

        }),
        calculateTotal() {
            let amount = 0;
            let total = this.details.reduce((carry, detail) => {
                amount = detail.amount;
                if (!detail.amount) {
                    amount = 0
                }
                return carry + parseFloat(amount)
            }, 0);
            return parseFloat(total).toFixed(2);
        }

    },
    methods: {
        showTransactionModal() {
            this.form.payoff_status_id = this.payoff_status_id;
            this.$refs.transaction.show();
        },
        hideTransactionsModal() {
            this.$refs.transaction.hide();
        },
        accountLabel(option) {
            return `${option.account} - ${option.name}`
        },
        addOtherDetails() {
            this.$store.dispatch("InvoicePayoff/addOtherDetails")
        },
        removeOtherDetails(index) {
            this.$store.dispatch("InvoicePayoff/removeOtherDetails", index - 1)
        },
        goToTransaction() {
            if (!this.form.date) {
                alert('กรุณาเลือกวันที่');
            } else if (!this.form.customer || this.form.customer.length < 1) {
                alert('กรุณาเลือกลูกค้า')
            } else {
                this.form.amount = this.calculateTotal;
                this.form.user_id = this.user.id;
                this.form.other_details = this.details;
                this.form.payoff_status_id = this.payoff_status_id;
                //console.log(this.form.payoff_status_id);
                if (this.form.customer) {
                    this.form.customer_id = this.form.customer.id;
                }
                this.$router.push("/invoice-payoff-other-transactions")
            }
        },
        saveInvoicePayoffOther(submit) {
            //console.log(submit);
            if (submit) {
                this.invoice_payoff = submit;
                this.$store.dispatch("InvoicePayoff/saveOtherDetails", {
                    id: submit.id,
                    data: submit
                }).then(() => {
                    this.$store.dispatch("InvoicePayoff/getInvoicePayoffOtherList")
                })
                this.$router.push({
                    name: "invoice-payoff-other" //InvoicePayoffTransactionModal.vue
                })
            }
        },
        goToInvoiceOtherList() {
            this.$router.push("/accounting/invoice-payoff-other")
        },
        getCustomerAll() {
            this.$store.dispatch("Customer/setAllCustomer").then(customers => {
                this.optionCustomer = customers;
            });
        }
    }
}
</script>

<style scoped>
thead {
    background-color: darkgrey;
    color: black;
}

tbody {
    background-color: white;
    color: black;
}
</style>
